import { Fragment } from 'react';
import { Trans } from 'react-i18next';

import core from 'root/util/core';
import { LazyLoadImage } from 'root/webapp/components/ss2/atoms/image';

// HOMEPAGE DATA
export const imgTopMatch = ['/public/html/images/home_img/feature1-slots.jpg'];
export const imgRealtime = ['/public/html/images/home_img/feature3-score.jpg'];
export const imgLiveStream = ['/public/html/images/home_img/feature2-streaming.jpg'];
export const hotGameIcon = ['/public/html/images/home_img/fire.png'];
export const newGameIcon = ['/public/html/images/home_img/newGame.png'];
export const lastestPromoIcon = ['/public/html/images/home_img/promo.png'];
export const MobilehotGameIcon = ['/public/html/images/home_img/m_fire.png'];
export const promoIcon = ['/public/html/images/home_img/promo.png'];
export const promoTopPick = ['/public/html/images/home_img/top-pick.png'];
export const casinoIcon = ['/public/html/images/home_img/casino.png'];
export const casinoIcon2 = ['/public/html/images/home_img/casino2.png'];
export const liveCasinoLogo = {
    SA: '/public/html/default_whitelabel/template/images/casino-roadmap/icon/casino_logo_sa.png',
    AG2: '/public/html/default_whitelabel/template/images/casino-roadmap/icon/casino_logo_ag2.png',
};
export const liveIcon = ['/public/html/images/home_img/home_icon_live.png'];
export const jackpotIcon = ['/public/html/images/home_img/jackpot_icon.png'];
export const highlightVideoIcon = ['/public/html/images/home_img/home_icon_highlightvid.png'];
export const hotGameTitle = ['/public/html/images/home_img/home_title_slot-game.png'];
export const maxbet = ['/public/html/images/home_img/sportsbook-maxbet.png'];
export const sidebarVIPIcon = '/public/html/images/drawer_img/VIP.png';
export const p88Logo = '/public/html/images/home_img/p88Logo.png';
export const topRankingIcon = '/public/html/images/home_img/top_ranking.png';
export const hotGameLogo = ['/public/html/images/home_img/hotGameLogo.png'];
export const sportNewIcon = ['/public/html/images/home_img/sportNewIcon.png'];

export const infoItems = [
    {
        id: '1',
        name: 'affiliate',
        imgprovider: 'affiliate',
        title: 'global:footer.affiliate-program.header',
        text: 'global:footer.joinNow',
        route: '/affiliate',
    },
    {
        id: '2',
        name: '',
        imgprovider: 'vip',
        title: 'global:footer.vip-program.header',
        text: 'global:footer.applyNow',
        route: '/vip',
    },
    {
        id: '3',
        name: 'promotion',
        imgprovider: 'specialpromo',
        title: 'global:footer.special-promotion.header',
        text: 'global:footer.playNow',
        route: '/promotion',
    },
    {
        id: '4',
        name: 'contact',
        imgprovider: 'customerservice',
        title: 'global:footer.customer-service.header',
        text: 'global:footer.chatNow',
        route: '',
    },
    {
        id: '5',
        name: 'livetv',
        imgprovider: 'live',
        title: 'global:footer.live-streaming.header',
        text: 'global:footer.watchNow',
        route: '/livetv',
    },
];

export const sideHotSlider = [
    {
        id: '1',
        name: 'Recent Play',
        title: 'global:global.banner.recentPlay',
        submenu: [
            {
                id: 1.11,
                name: 'GG Gaming',
                img: '/public/html/images/drawer_img/gg.png',
                imghover: '/public/html/images/drawer_img/gg.png',
                alturlhover: 'GG Fishing',
                text: 'GG Gaming',
                route: '/fishing/sg-fishing',
            },
        ],
    },

    {
        id: '2',
        name: 'New Games',
        title: 'global:global.banner.newGames',
        submenu: [
            {
                id: 2.11,
                img: '/public/html/images/drawer_img/sg.png',
                imghover: '/public/html/images/drawer_img/sg.png',
                alturlhover: 'SG-Slots',
                text: 'SG Slots',
                route: '/slots/spadeGaming',
            },
            {
                id: 2.12,
                img: '/public/html/images/drawer_img/cmd.png',
                imghover: '/public/html/images/drawer_img/cmd.png',
                alturlhover: 'C-Sports',
                text: 'C-Sports',
                route: '/sports/cmd368',
            },
            {
                id: 2.13,
                img: '/public/html/images/drawer_img/ultimate.png',
                imghover: '/public/html/images/drawer_img/ultimate.png',
                alturlhover: 'Ultimate',
                text: 'ULTIMATE',
                route: '/ultimate-slots',
            },
        ],
    },

    {
        id: '3',
        name: 'Hot Games',
        title: 'global:global.banner.hotGame',
        submenu: [
            {
                id: 3.11,
                img: '/public/html/images/drawer_img/casino-pt.png',
                imghover: '/public/html/images/drawer_img/casino-pt.png',
                alturlhover: '12Win Rolex',
                text: '12Win Rolex',
                route: '/slots/playTech',
            },
            {
                id: 3.12,
                img: '/public/html/images/drawer_img/ttg.png',
                imghover: '/public/html/images/drawer_img/ttg.png',
                alturlhover: 'TTG Slots',
                text: 'TTG Slots',
                route: '/slots/toptrendgaming',
            },
            {
                id: 3.13,
                img: '/public/html/images/drawer_img/allbet.png',
                imghover: '/public/html/images/drawer_img/allbet.png',
                alturlhover: 'Allbet',
                text: 'ALLBET',
                route: '/casino/allbet2',
            },
            {
                id: 3.14,
                img: '/public/html/images/drawer_img/gd.png',
                imghover: '/public/html/images/drawer_img/gd.png',
                alturlhover: 'GD',
                text: 'GD GAMING',
                route: '/casino/gd-gaming',
            },
        ],
    },
];

// REGISTER DATA
export const registerEmail = ['/public/html/images/icon/register-mail.png'];
export const registerContact = ['/public/html/images/icon/register-contact.png'];
export const registerCurrency = ['/public/html/images/icon/register-currency.png'];
export const registerUser = ['/public/html/images/icon/register-user.png'];
export const registerDOB = ['/public/html/images/icon/register-dob.png'];
export const registerPassword = ['/public/html/images/icon/register-password.png'];
export const registerAFF = ['/public/html/images/icon/register-affiliate.png'];

export const brandLogoMobile = ['/public/html/images/common_img/hdr-logo.png'];

// LICENSES DATA
export const licensesData = [
    {
        name: 'Licenses',
        text: 'global:footer.license',
        providers: [
            {
                id: 2.1,
                name: 'Pagcor',
                img: '/public/html/images/footer/ftr_reco_pagcor_of.png',
                imgHover: '/public/html/images/footer/ftr_reco_pagcor_ov.png',
                imgMobile: '/public/html/images/footer/ftr_reco_pagcor_of_mobile.png',
            },
            {
                id: 2.2,
                name: 'BMM',
                img: '/public/html/images/footer/ftr_reco_bmm_of.png',
                imgHover: '/public/html/images/footer/ftr_reco_bmm_ov.png',
                imgMobile: '/public/html/images/footer/ftr_reco_bmm_of_mobile.png',
            },
            {
                id: 2.3,
                name: 'godaddy',
                img: '/public/html/images/footer/ftr_reco_veri_of.png',
                imgHover: '/public/html/images/footer/ftr_reco_veri_ov.png',
                imgMobile: '/public/html/images/footer/ftr_reco_veri_of_mobile.png',
            },
            {
                id: 2.6,
                name: 'tt',
                img: '/public/html/images/footer/ftr_reco_tt_of.png',
                imgHover: '/public/html/images/footer/ftr_reco_tt_ov.png',
                imgMobile: '/public/html/images/footer/ftr_reco_tt_of_mobile.png',
            },
            {
                id: 2.4,
                name: 'itech',
                img: '/public/html/images/footer/ftr_reco_itech_of.png',
                imgHover: '/public/html/images/footer/ftr_reco_itech_ov.png',
                imgMobile: '/public/html/images/footer/ftr_reco_itech_of_mobile.png',
            },
            {
                id: 2.5,
                name: 'recoCert',
                img: '/public/html/images/footer/ftr_reco_cert_of.png',
                imgHover: '/public/html/images/footer/ftr_reco_cert_ov.png',
                imgMobile: '/public/html/images/footer/ftr_reco_cert_of_mobile.png',
            },
            {
                id: 2.7,
                name: 'curacao',
                img: '/public/html/images/footer/ftr_curacao_of.png',
                imgHover: '/public/html/images/footer/ftr_curacao_ov.png',
                imgMobile: '/public/html/images/footer/ftr_curacao_of_mobile.png',
            },
        ],
    },
];

// PAYMENT METHOD DATA
export const paymentMethodData = [
    {
        name: 'Payment Method',
        text: 'global:footer.payment-method',
        providers: [
            {
                id: 3.1,
                name: 'EeziePay',
                img: '/public/html/images/footer/ftr_pay_eezie_of.png',
                imgHover: '/public/html/images/footer/ftr_pay_eezie_ov.png',
                imgMobile: '/public/html/images/footer/ftr_pay_eezie_of_mobile.png',
            },
            {
                id: 3.2,
                name: 'PayTrust',
                img: '/public/html/images/footer/paytrust88_hover.png',
                imgHover: '/public/html/images/footer/paytrust88_hover.png',
                imgMobile: '/public/html/images/footer/ftr_pay_pt88_of_mobile.png',
            },
            {
                id: 3.3,
                name: 'Help2Pay',
                img: '/public/html/images/footer/help2pay_hover.png',
                imgHover: '/public/html/images/footer/help2pay_hover.png',
                imgMobile: '/public/html/images/footer/ftr_pay_h2p_of_mobile.png',
            },
        ],
        providers1: [
            {
                id: 3.1,
                name: 'EeziePay',
                img: '/public/html/images/footer/ftr_pay_eezie_of.png',
                imgHover: '/public/html/images/footer/ftr_pay_eezie_ov.png',
                imgMobile: '/public/html/images/footer/ftr_pay_eezie_of_mobile.png',
            },
            {
                id: 3.2,
                name: 'BankTransfer',
                img: '/public/html/images/footer/Bank-Transfer.png',
                imgHover: '/public/html/images/footer/Bank-Transfer.png',
                imgMobile: '/public/html/images/footer/Bank-Transfer.png',
            },
        ],
        providers2: [
            {
                id: 3.1,
                name: 'Ambank',
                img: '/public/html/images/bank_img/ftr-AmBank.png',
                imgHover: '/public/html/images/bank_img/ftr-AmBank.png',
                imgMobile: '/public/html/images/bank_img/ftr-AmBank.png',
            },
            {
                id: 3.2,
                name: 'BankIslam',
                img: '/public/html/images/bank_img/ftr-Bank_Islam.png',
                imgHover: '/public/html/images/bank_img/ftr-Bank_Islam.png',
                imgMobile: '/public/html/images/bank_img/ftr-Bank_Islam.png',
            },
            {
                id: 3.3,
                name: 'BSN',
                img: '/public/html/images/bank_img/ftr-BSN_Bank.png',
                imgHover: '/public/html/images/bank_img/ftr-BSN_Bank.png',
                imgMobile: '/public/html/images/bank_img/ftr-BSN_Bank.png',
            },
            {
                id: 3.4,
                name: 'HLB',
                img: '/public/html/images/bank_img/ftr-HLB_Bank.png',
                imgHover: '/public/html/images/bank_img/ftr-HLB_Bank.png',
                imgMobile: '/public/html/images/bank_img/ftr-HLB_Bank.png',
            },
            {
                id: 3.5,
                name: 'MBB',
                img: '/public/html/images/bank_img/ftr-MayBank.png',
                imgHover: '/public/html/images/bank_img/ftr-MayBank.png',
                imgMobile: '/public/html/images/bank_img/ftr-MayBank.png',
            },
            {
                id: 3.6,
                name: 'Ambank',
                img: '/public/html/images/bank_img/ftr-AmBank.png',
                imgHover: '/public/html/images/bank_img/ftr-AmBank.png',
                imgMobile: '/public/html/images/bank_img/ftr-AmBank.png',
            },
            {
                id: 3.7,
                name: 'RHB',
                img: '/public/html/images/bank_img/ftr-RHB_Bank.png',
                imgHover: '/public/html/images/bank_img/ftr-RHB_Bank.png',
                imgMobile: '/public/html/images/bank_img/ftr-RHB_Bank.png',
            },
            {
                id: 3.8,
                name: 'PBE',
                img: '/public/html/images/bank_img/ftr-Public_Bank.png',
                imgHover: '/public/html/images/bank_img/ftr-Public_Bank.png',
                imgMobile: '/public/html/images/bank_img/ftr-Public_Bank.png',
            },
        ],
        providers3: [
            {
                id: 3.1,
                name: 'EeziePay',
                img: '/public/html/images/footer/ftr_pay_eezie_of.png',
                imgHover: '/public/html/images/footer/ftr_pay_eezie_ov.png',
                imgMobile: '/public/html/images/footer/ftr_pay_eezie_of_mobile.png',
            },
            {
                id: 3.2,
                name: 'Help2Pay',
                img: '/public/html/images/footer/help2pay_hover.png',
                imgHover: '/public/html/images/footer/help2pay_hover.png',
                imgMobile: '/public/html/images/footer/ftr_pay_h2p_of_mobile.png',
            },
        ],
        providers4: [
            {
                id: 4.1,
                name: 'aba',
                img: '/public/html/images/footer/ftr-payment-aba-on.png',
                imgHover: '/public/html/images/footer/ftr-payment-aba-on.png',
            },
            {
                id: 4.2,
                name: 'acleda',
                img: '/public/html/images/footer/ftr-payment-acleda-on.png',
                imgHover: '/public/html/images/footer/ftr-payment-acleda-on.png',
            },
            {
                id: 4.3,
                name: 'tm',
                img: '/public/html/images/footer/ftr-payment-tm-on.png',
                imgHover: '/public/html/images/footer/ftr-payment-tm-on.png',
            },
            {
                id: 4.4,
                name: 'wing',
                img: '/public/html/images/footer/ftr-payment-wing-on.png',
                imgHover: '/public/html/images/footer/ftr-payment-wing-on.png',
            },
        ],
    },
];

// SUPPORT BANK DATA
export const supportedBankData = [
    {
        name: 'Supported Bank',
        text: 'global:footer.supported-bank',
        providers: [
            {
                id: 6.1,
                name: 'AmBank',
                img: '/public/html/images/bank_img/bank-AMB_of.png',
                imgHover: '/public/html/images/bank_img/bank-AMB.png',
                imgMobile: '/public/html/images/bank_img/bank-AMB_of.png',
            },
            {
                id: 6.2,
                name: 'BIMB Bank',
                img: '/public/html/images/bank_img/bank-BIMB_of.png',
                imgHover: '/public/html/images/bank_img/bank-BIMB.png',
                imgMobile: '/public/html/images/bank_img/bank-BIMB_of.png',
            },
            {
                id: 6.3,
                name: 'Bank Rakyat',
                img: '/public/html/images/bank_img/bank-BR_of.png',
                imgHover: '/public/html/images/bank_img/bank-BR.png',
                imgMobile: '/public/html/images/bank_img/bank-BR.png',
            },
            {
                id: 6.4,
                name: 'Bank BSN',
                img: '/public/html/images/bank_img/bank-BSN_of.png',
                imgHover: '/public/html/images/bank_img/bank-BSN.png',
                imgMobile: '/public/html/images/bank_img/bank-BSN_of.png',
            },
            {
                id: 6.5,
                name: 'Bank CIMB',
                img: '/public/html/images/bank_img/bank-cimb.png',
                imgHover: '/public/html/images/bank_img/bank-cimb_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-cimb.png',
            },
            {
                id: 6.5,
                name: 'Bank CIMB Niaga',
                img: '/public/html/images/bank_img/bank-CIMBN_of.png',
                imgHover: '/public/html/images/bank_img/bank-CIMBN.png',
                imgMobile: '/public/html/images/bank_img/bank-CIMBN.png',
            },
            {
                id: 6.6,
                name: 'Bank Citi',
                img: '/public/html/images/bank_img/bank-citi_of.png',
                imgHover: '/public/html/images/bank_img/bank-citi.png',
                imgMobile: '/public/html/images/bank_img/bank-citi.png',
            },
            {
                id: 6.7,
                name: 'DBS Bank',
                img: '/public/html/images/bank_img/bank-DBS_of.png',
                imgHover: '/public/html/images/bank_img/bank-DBS.png',
                imgMobile: '/public/html/images/bank_img/bank-DBS.png',
            },
            {
                id: 6.8,
                name: 'Government Housing Bank',
                img: '/public/html/images/bank_img/bank-GHB_of.png',
                imgHover: '/public/html/images/bank_img/bank-GHB.png',
                imgMobile: '/public/html/images/bank_img/bank-GHB.png',
            },
            {
                id: 6.9,
                name: 'Government Savings Bank',
                img: '/public/html/images/bank_img/bank-GSB_of.png',
                imgHover: '/public/html/images/bank_img/bank-GSB.png',
                imgMobile: '/public/html/images/bank_img/bank-GSB.png',
            },
            {
                id: 6.1,
                name: 'HSBC Bank',
                img: '/public/html/images/bank_img/bank-HSBC_of.png',
                imgHover: '/public/html/images/bank_img/bank-HSBC.png',
                imgMobile: '/public/html/images/bank_img/bank-HSBC.png',
            },
            {
                id: 6.11,
                name: 'Land and Houses Bank',
                img: '/public/html/images/bank_img/bank-LH_of.png',
                imgHover: '/public/html/images/bank_img/bank-LH.png',
                imgMobile: '/public/html/images/bank_img/bank-LH.png',
            },
            {
                id: 6.12,
                name: 'OCBC Bank',
                img: '/public/html/images/bank_img/bank-OCBC_of.png',
                imgHover: '/public/html/images/bank_img/bank-OCBC.png',
                imgMobile: '/public/html/images/bank_img/bank-OCBC.png',
            },
            {
                id: 6.13,
                name: 'SCB Bank',
                img: '/public/html/images/bank_img/bank-SCB_of.png',
                imgHover: '/public/html/images/bank_img/bank-SCB.png',
                imgMobile: '/public/html/images/bank_img/bank-SCB.png',
            },
            {
                id: 6.14,
                name: 'Thanachart Bank',
                img: '/public/html/images/bank_img/bank-thanachart.png',
                imgHover: '/public/html/images/bank_img/bank-thanachart_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-thanachart_ov.png',
            },
            {
                id: 6.15,
                name: 'UOB Bank',
                img: '/public/html/images/bank_img/bank-UOB_of.png',
                imgHover: '/public/html/images/bank_img/bank-UOB.png',
                imgMobile: '/public/html/images/bank_img/bank-UOB.png',
            },
            {
                id: 6.16,
                name: 'ALB Bank',
                img: '/public/html/images/bank_img/bank-alb_of.png',
                imgHover: '/public/html/images/bank_img/bank-alb.png',
                imgMobile: '/public/html/images/bank_img/bank-alb.png',
            },
            {
                id: 6.17,
                name: 'POSB Bank',
                img: '/public/html/images/bank_img/bank-posb_of.png',
                imgHover: '/public/html/images/bank_img/bank-posb.png',
                imgMobile: '/public/html/images/bank_img/bank-posb.png',
            },
            {
                id: 6.18,
                name: 'HLB Bank',
                img: '/public/html/images/bank_img/bank-hlb_of.png',
                imgHover: '/public/html/images/bank_img/bank-hlb.png',
                imgMobile: '/public/html/images/bank_img/bank-hlb.png',
            },
            {
                id: 6.19,
                name: 'Bangkok Bank',
                img: '/public/html/images/bank_img/bank-bangkok.png',
                imgHover: '/public/html/images/bank_img/bank-bangkok_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-bangkok_ov.png',
            },
            {
                id: 6.2,
                name: 'affin Bank',
                img: '/public/html/images/bank_img/bank-affin_of.png',
                imgHover: '/public/html/images/bank_img/bank-affin.png',
                imgMobile: '/public/html/images/bank_img/bank-affin .png',
            },
            {
                id: 6.21,
                name: 'affin Islamic Bank',
                img: '/public/html/images/bank_img/bank-affin-islamic_of.png',
                imgHover: '/public/html/images/bank_img/bank-affin.png',
                imgMobile: '/public/html/images/bank_img/bank-affin .png',
            },
            {
                id: 6.22,
                name: 'BCA Bank',
                img: '/public/html/images/bank_img/bank-bca_of.png',
                imgHover: '/public/html/images/bank_img/bank-bca.png',
                imgMobile: '/public/html/images/bank_img/bank-bca.png',
            },
            // duplicated
            // {
            //   id: 6.23,
            //   name: 'BIMB Bank',
            //   img: '/public/html/images/bank_img/bank-BIMB_of.png',
            //   imgHover: '/public/html/images/bank_img/bank-BIMB.png',
            //   imgMobile: '/public/html/images/bank_img/bank-BIMB.png'
            // },
            {
                id: 6.24,
                name: 'Bank for Agriculture and Agricultural Cooperatives',
                img: '/public/html/images/bank_img/bank-for-agriculture-and-agricultural-cooperatives_of.png',
                imgHover: '/public/html/images/bank_img/bank-for-agriculture-and-agricultural-cooperatives.png',
                imgMobile: '/public/html/images/bank_img/bank-for-agriculture-and-agricultural-cooperatives.png',
            },
            {
                id: 6.25,
                name: 'Islam Bank',
                img: '/public/html/images/bank_img/bank-islam_of.png',
                imgHover: '/public/html/images/bank_img/bank-islam.png',
                imgMobile: '/public/html/images/bank_img/bank-islam.png',
            },
            {
                id: 6.26,
                name: 'Deutsche Bank',
                img: '/public/html/images/bank_img/bank-deutsche_of.png',
                imgHover: '/public/html/images/bank_img/bank-deutsche.png',
                imgMobile: '/public/html/images/bank_img/bank-deutsche.png',
            },
            {
                id: 6.27,
                name: 'TMB Bank',
                img: '/public/html/images/bank_img/bank-tmb.png',
                imgHover: '/public/html/images/bank_img/bank-tmb_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-tmb_ov.png',
            },
            {
                id: 6.28,
                name: 'BNI Bank',
                img: '/public/html/images/bank_img/bank-bni_of.png',
                imgHover: '/public/html/images/bank_img/bank-bni.png',
                imgMobile: '/public/html/images/bank_img/bank-bni.png',
            },
            {
                id: 6.29,
                name: 'BRI Bank',
                img: '/public/html/images/bank_img/bank-bri_of.png',
                imgHover: '/public/html/images/bank_img/bank-bri.png',
                imgMobile: '/public/html/images/bank_img/bank-bri.png',
            },
            {
                id: 6.3,
                name: 'United Overseas Bank',
                img: '/public/html/images/bank_img/bank-united-overseas_of.png',
                imgHover: '/public/html/images/bank_img/bank-united-overseas.png',
                imgMobile: '/public/html/images/bank_img/bank-united-overseas.png',
            },
            {
                id: 6.31,
                name: 'Mandiri Bank',
                img: '/public/html/images/bank_img/bank-mandiri_of.png',
                imgHover: '/public/html/images/bank_img/bank-mandiri.png',
                imgMobile: '/public/html/images/bank_img/bank-mandiri.png',
            },
            {
                id: 6.32,
                name: 'MayBank',
                img: '/public/html/images/bank_img/bank-mbb_of.png',
                imgHover: '/public/html/images/bank_img/bank-mbb.png',
                imgMobile: '/public/html/images/bank_img/bank-mbb.png',
            },
            {
                id: 6.33,
                name: '/public Bank',
                img: '/public/html/images/bank_img/bank-pbb_of.png',
                imgHover: '/public/html/images/bank_img/bank-pbb.png',
                imgMobile: '/public/html/images/bank_img/bank-pbb.png',
            },
            {
                id: 6.34,
                name: 'RHB Bank',
                img: '/public/html/images/bank_img/bank-rhb_of.png',
                imgHover: '/public/html/images/bank_img/bank-rhb.png',
                imgMobile: '/public/html/images/bank_img/bank-rhb.png',
            },
            {
                id: 6.35,
                name: 'Islamic Bank',
                img: '/public/html/images/bank_img/bank-islamic_of.png',
                imgHover: '/public/html/images/bank_img/bank-islamic.png',
                imgMobile: '/public/html/images/bank_img/bank-islamic.png',
            },
            {
                id: 6.36,
                name: 'Kasikorn Bank',
                img: '/public/html/images/bank_img/bank-kasikorn.png',
                imgHover: '/public/html/images/bank_img/bank-kasikorn_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-kasikorn_ov.png',
            },
            {
                id: 6.37,
                name: 'kiatnakin Bank',
                img: '/public/html/images/bank_img/bank-kiatnakin_of.png',
                imgHover: '/public/html/images/bank_img/bank-kiatnakin.png',
                imgMobile: '/public/html/images/bank_img/bank-kiatnakin.png',
            },
            {
                id: 6.38,
                name: 'Krungsi Bank',
                img: '/public/html/images/bank_img/bank-krungsi_of.png',
                imgHover: '/public/html/images/bank_img/bank-krungsi.png',
                imgMobile: '/public/html/images/bank_img/bank-krungsi.png',
            },
            {
                id: 6.39,
                name: 'Krungthai Bank',
                img: '/public/html/images/bank_img/bank-krungthai.png',
                imgHover: '/public/html/images/bank_img/bank-krungthai_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-krungthai_ov.png',
            },
            {
                id: 6.4,
                name: 'KTB Netbank',
                img: '/public/html/images/bank_img/bank-ktb-netbank_of.png',
                imgHover: '/public/html/images/bank_img/bank-ktb-netbank.png',
                imgMobile: '/public/html/images/bank_img/bank-ktb-netbank.png',
            },
            {
                id: 6.41,
                name: 'Siam Bank',
                img: '/public/html/images/bank_img/bank-siam.png',
                imgHover: '/public/html/images/bank_img/bank-siam_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-siam_ov.png',
            },
            {
                id: 6.42,
                name: 'Tisco Bank',
                img: '/public/html/images/bank_img/bank-tisco_of.png',
                imgHover: '/public/html/images/bank_img/bank-tisco.png',
                imgMobile: '/public/html/images/bank_img/bank-tisco.png',
            },
            {
                id: 6.43,
                name: 'Ayudhy Bank',
                img: '/public/html/images/bank_img/bank-ayudhy.png',
                imgHover: '/public/html/images/bank_img/bank-ayudhy_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-ayudhy_ov.png',
            },
            /* VND BankS */
            {
                id: 6.44,
                code: 'ACB',
                name: 'Asia Commercial Bank',
                img: '/public/html/images/bank_img/bank-acb_of.png',
                imgHover: '/public/html/images/bank_img/bank-acb_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-acb_ov.png',
            },
            {
                id: 6.45,
                code: 'DAB',
                name: 'DongA Joint Stock Commercial Bank',
                img: '/public/html/images/bank_img/bank-dab_of.png',
                imgHover: '/public/html/images/bank_img/bank-dab_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-dab_ov.png',
            },
            {
                id: 6.46,
                code: 'SACOM',
                name: 'Sacom Bank',
                img: '/public/html/images/bank_img/bank-sacom_of.png',
                imgHover: '/public/html/images/bank_img/bank-sacom_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-sacom_ov.png',
            },
            {
                id: 6.47,
                code: 'TCB',
                name: 'Techcom Bank',
                img: '/public/html/images/bank_img/bank-tcb_of.png',
                imgHover: '/public/html/images/bank_img/bank-tcb_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-tcb_ov.png',
            },
            {
                id: 6.48,
                code: 'VCB',
                name: 'Vietcom Bank',
                img: '/public/html/images/bank_img/bank-vcb_of.png',
                imgHover: '/public/html/images/bank_img/bank-vcb_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-vcb_ov.png',
            },
            {
                id: 6.49,
                code: 'VTB',
                name: 'Vietin Bank',
                img: '/public/html/images/bank_img/bank-vtb_of.png',
                imgHover: '/public/html/images/bank_img/bank-vtb_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-vtb_ov.png',
            },
            {
                id: 6.5,
                code: 'EXIM',
                name: 'Eximbank Vietnam',
                img: '/public/html/images/bank_img/bank-exim_of.png',
                imgHover: '/public/html/images/bank_img/bank-exim_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-exim_ov.png',
            },
            {
                id: 6.51,
                code: 'BIDV',
                name: 'Bank for Investment and Development of Vietnam',
                img: '/public/html/images/bank_img/bank-bidv_of.png',
                imgHover: '/public/html/images/bank_img/bank-bidv_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-bidv_of.png',
            },
            {
                id: 6.52,
                code: 'SCMB',
                name: 'SAIGON Bank',
                img: '/public/html/images/bank_img/bank-scmb_of.png',
                imgHover: '/public/html/images/bank_img/bank-scmb_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-scmb_ov.png',
            },
            {
                id: 6.53,
                code: 'VIB',
                name: 'Vietnam International Bank',
                img: '/public/html/images/bank_img/bank-vib_of.png',
                imgHover: '/public/html/images/bank_img/bank-vib_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-vib_ov.png',
            },
            {
                id: 6.54,
                code: 'AGB',
                name: 'Agribank',
                img: '/public/html/images/bank_img/bank-agb_of.png',
                imgHover: '/public/html/images/bank_img/bank-agb_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-agb_ov.png',
            },
            {
                id: 6.55,
                code: 'VPB',
                name: 'Vietnam Prosperity Joint-Stock Commercial Bank',
                img: '/public/html/images/bank_img/bank-vpb_of.png',
                imgHover: '/public/html/images/bank_img/bank-vpb_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-vpb_ov.png',
            },
            {
                id: 6.56,
                code: 'MSCB',
                name: 'Military Commercial Joint Stock Bank',
                img: '/public/html/images/bank_img/bank-mscb_of.png',
                imgHover: '/public/html/images/bank_img/bank-mscb_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-mscb_ov.png',
            },
            {
                id: 6.57,
                code: 'TPB',
                name: 'Tien Phong Commercial',
                img: '/public/html/images/bank_img/bank-tpb_of.png',
                imgHover: '/public/html/images/bank_img/bank-tpb_ov.png',
                imgMobile: '/public/html/images/bank_img/bank-tpb_ov.png',
            },
            /* VND BankS end */
        ],
    },
];

// FOLLOW US DATA
export const FollowUsData = [
    {
        name: 'Follow Us',
        text: 'global:footer.follow-us',
        providers: [
            {
                id: 4.11,
                name: 'Fb',
                img: '/public/html/default_whitelabel/template/images/follow-us/ftr_social_fb_of.png',
                imgHover: '/public/html/default_whitelabel/template/images/follow-us/ftr_social_fb_ov.png',
            },
            {
                id: 4.12,
                name: 'Yt',
                img: '/public/html/default_whitelabel/template/images/follow-us/ftr_social_yt_of.png',
                imgHover: '/public/html/default_whitelabel/template/images/follow-us/ftr_social_yt_ov.png',
            },
        ],
    },
];

// SUGGESTED BROWSER DATA
export const SuggestedBrowserData = [
    {
        name: 'Suggested Browser',
        text: 'global:footer.suggest-browser',
        providers: [
            {
                id: 5.11,
                name: 'Chrome',
                img: '/public/html/images/footer/ftr_browser_chrome_of.png',
                imgHover: '/public/html/images/footer/ftr_browser_chrome_ov.png',
            },
            {
                id: 5.12,
                name: 'IE',
                img: '/public/html/images/footer/ftr_browser_ie_of.png',
                imgHover: '/public/html/images/footer/ftr_browser_ie_ov.png',
            },
            {
                id: 5.13,
                name: 'FireFox',
                img: '/public/html/images/footer/ftr_browser_ff_of.png',
                imgHover: '/public/html/images/footer/ftr_browser_ff_ov.png',
            },
        ],
    },
];

// COMMITED SUPPORT DATA
export const commitedSupportData = [
    {
        name: 'Commited Support',
        text: 'global:footer.committed-to-support',
        providers: [
            {
                id: 5.1,
                name: 'Gamble Aware',
                img: '/public/html/images/new/footer/ftr_reco_gambleaware_of.png',
                imgHover: '/public/html/images/footer/ftr_reco_gambleaware_ov.png',
            },
            {
                id: 5.2,
                name: 'GA',
                img: '/public/html/images/new/footer/ftr_reco_ga_of.png',
                imgHover: '/public/html/images/footer/ftr_reco_ga_ov.png',
            },
            {
                id: 5.3,
                name: 'Gambling Therapy',
                img: '/public/html/images/new/footer/ftr_reco_gambletherapy_of.png',
                imgHover: '/public/html/images/footer/ftr_reco_gambletherapy_ov.png',
            },
            {
                id: 5.4,
                name: 'Responsible Gambling',
                img: '/public/html/images/new/footer/ftr_reco_resgamblingthrust_of.png',
                imgHover: '/public/html/images/footer/ftr_reco_resgamblingthrust_ov.png',
            },
            {
                id: 5.5,
                name: 'GBGA',
                img: '/public/html/images/new/footer/ftr_reco_gbga_of.png',
                imgHover: '/public/html/images/footer/ftr_reco_gbga_ov.png',
            },
        ],
    },
];

// TEMPLATE 2 FOOTER ICON / IMAGE
export const afficon = ['/public/html/images/footer/Affiliate.png'];
export const cusicon = ['/public/html/images/footer/Customer.png'];
export const livestreamicon = ['/public/html/images/footer/LiveStream.png'];
export const reficon = ['/public/html/images/footer/ReferralProgram.png'];
export const vipicon = ['/public/html/images/footer/VIP-Program.png'];
export const lineicon = ['/public/html/images/footer/Asset 43.png'];
export const btm01 = ['/public/html/images/footer/bottom_1.png'];
export const btm02 = ['/public/html/images/footer/bottom_2.png'];

// TEMPLATE 2 HOME ICON / IMAGE
export const slotIcon = ['/public/html/images/home_img/home-slot.png'];
export const newsIcon = ['/public/html/images/home_img/home-trophy.png'];
export const diceIcon = ['/public/html/images/home_img/home-dice.png'];
export const spadeIcon = ['/public/html/images/home_img/home-spade.png'];
export const arrowNext = ['/public/html/images/home_img/arrow-next.png'];
export const arrowPrev = ['/public/html/images/home_img/arrow-prev.png'];
export const arrowNextSpec = ['/public/html/images/home_img/arrow-next-special.png'];
export const arrowPrevSpec = ['/public/html/images/home_img/arrow-prev-special.png'];

//TEMPLATE 2 AFTER LOGIN WALLET ICONS
export const mDeposit = ['/public/html/images/home_img/Deposit.png'];
export const mHistory = ['/public/html/images/home_img/History.png'];
export const mPromotions = ['/public/html/images/home_img/Promotions.png'];
export const mTransfer = ['/public/html/images/home_img/Transfer.png'];
export const mWithdraw = ['/public/html/images/home_img/Withdraw.png'];
export const mRefresh = ['/public/html/images/home_img/refresh.png'];
export const mRestore = ['/public/html/images/home_img/restore.png'];
export const meye = ['/public/html/images/home_img/eyeicon.png'];
export const moffeye = ['/public/html/images/home_img/offeye.png'];

//TEMPLATE 2 LIVE CASINO IMAGE
export const LiveCasinoData = [
    {
        id: 1,
        img: '/public/html/images/casino/Asset 11.png',
    },
    {
        id: 2,
        img: '/public/html/images/casino/Asset 12.png',
    },
    {
        id: 3,
        img: '/public/html/images/casino/Asset 3.png',
    },
    {
        id: 4,
        img: '/public/html/images/casino/Asset 4.png',
    },
    {
        id: 5,
        img: '/public/html/images/casino/Asset 5.png',
    },
    {
        id: 6,
        img: '/public/html/images/casino/Asset 6.png',
    },
    {
        id: 7,
        img: '/public/html/images/casino/Asset 7.png',
    },
    {
        id: 8,
        img: '/public/html/images/casino/Asset 8.png',
    },
    {
        id: 9,
        img: '/public/html/images/casino/Asset 9.png',
    },
    {
        id: 10,
        img: '/public/html/images/casino/Asset 10.png',
    },
];

export const nextButton = ['/public/html/images/home_img/button_right.png'];
export const prevButton = ['/public/html/images/home_img/button_left.png'];

// referrel video source
export const refferVideo = [
    { id: 1, videoSelect: 'video_01', src: '/public/html/content/sponsors-video/vid1.mp4' },
    { id: 2, videoSelect: 'video_02', src: '/public/html/content/sponsors-video/vid2.mp4' },
    { id: 3, videoSelect: 'video_03', src: '/public/html/content/sponsors-video/vid3.mp4' },
    { id: 4, videoSelect: 'video_04', src: '/public/html/content/sponsors-video/vid4.mp4' },
    { id: 5, videoSelect: 'video_05', src: '/public/html/content/sponsors-video/vid5.mp4' },
    { id: 6, videoSelect: 'video_06', src: '/public/html/content/sponsors-video/vid6.mp4' },
    { id: 7, videoSelect: 'video_07', src: '/public/html/content/sponsors-video/vid7.mp4' },
];

// Products source
export const InforCenterData = [
    {
        id: 1,
        name: 'Products',
        text: 'global:footer.products',
        providers: [
            {
                id: 2.1,
                name: 'home:home.liveCasino',
                route: '/casino-landing',
            },
            {
                id: 2.2,
                name: 'affiliate:affiliate.home.products.sportsbook',
                route: '/sports-landing',
            },
            {
                id: 2.3,
                name: 'home:home.slotClub',
                route: '/slots/nextspin',
            },
            {
                id: 2.4,
                name: 'home:home.lottery',
                route: '/lottery',
            },
        ],
    },
    {
        id: 2,
        name: 'Payment',
        text: 'global:footer.payment-method',
        providers: [
            {
                id: 2.1,
                name: 'EeziePay',
            },
            {
                id: 2.2,
                name: 'PayTrust88',
            },
            {
                id: 2.3,
                name: 'Help2Pay',
            },
        ],
    },
    {
        id: 3,
        name: 'links',
        text: 'global:footer.links',
        providers: [
            {
                id: 2.1,
                name: 'global:footer.about-us',
                route: '/aboutus',
                key: 'about-us',
            },
            {
                id: 2.2,
                name: 'global:footer.terms-and-condition',
                route: '/terms',
                key: 'terms',
            },
            {
                id: 2.3,
                name: 'global:infoCentre.promotions',
                route: '/promotion',
                // hide promotion key to fulfill the logic in inforCenter.js and route when click.
                // key: '/promotion',
            },
            {
                id: 2.4,
                name: 'global:infoCentre.privacypolicy',
                route: '/privacy-policy',
                key: 'privacy-policy',
            },
            {
                id: 2.5,
                name: 'global:footer.affiliate',
            },
        ],
    },
    {
        id: 4,
        name: 'help',
        text: 'global:footer.help',
        providers: [
            {
                id: 2.1,
                name: 'global:infoCentre:option_2',
                route: '/help/how-to-deposit',
            },
            {
                id: 2.2,
                name: 'global:infoCentre:option_3',
                route: '/help/how-to-withdraw',
            },
            {
                id: 2.3,
                name: 'global:infoCentre:option_4',
                route: '/help/how-to-Instant-Deposit',
            },
        ],
    },
    {
        id: 5,
        name: 'information',
        text: 'global:footer.help',
        providers: [
            {
                id: 5.1,
                name: 'global:infoCentre:option_6',
                route: '/help/how-to-register',
            },
            {
                id: 5.2,
                name: 'global:infoCentre:option_2',
                route: '/help/how-to-deposit',
            },
            {
                id: 5.3,
                name: 'global:infoCentre:option_3',
                route: '/help/how-to-withdraw',
            },
            {
                id: 5.4,
                name: 'global:infoCentre:option_5',
                route: '/help/how-to-transfer',
            },
        ],
    },
];

// Products source
export const AffInforCenterData = [
    {
        id: 1,
        name: 'Payment',
        text: 'global:footer.payment-method',
        providers: [
            {
                id: 2.1,
                name: 'EeziePay',
            },
            {
                id: 2.2,
                name: 'PayTrust88',
            },
            {
                id: 2.3,
                name: 'Help2Pay',
            },
        ],
    },
    {
        id: 2,
        name: 'links',
        text: 'global:footer.links',
        providers: [
            {
                id: 2.1,
                name: 'global:footer.about-us',
                route: '/aboutus',
            },
            {
                id: 2.2,
                name: 'global:footer.terms-and-condition',
                route: '/terms',
            },
        ],
    },
];

export const hotCasinoSlider = [
    {
        id: '1',
        provider: 'SA Gaming',
        path: '/public/html/images/home_img/home-casino-sa.jpg',
        route: '/casino/sa-gaming',
    },
    {
        id: '2',
        provider: 'Play Tech',
        path: '/public/html/images/home_img/home-casino-pt.jpg',
        route: '/casino/playtech',
    },
    {
        id: '3',
        provider: 'GamePlay',
        path: '/public/html/images/home_img/home-casino-gp.jpg',
        route: '/casino/gameplay',
    },
    {
        id: '4',
        provider: 'MicroGaming',
        path: '/public/html/images/home_img/home-casino-mg.jpg',
        route: '/casino/microGamingPlus',
    },
    {
        id: '5',
        provider: 'AllBet2',
        path: '/public/html/images/home_img/home-casino-allbet.jpg',
        route: '/casino/allbet2',
    },
];

export const ip9HomeSlot = [
    {
        id: '1',
        imgPath: '/public/html/images/home_img/home-slots-sg.png',
        imgPathOv: '/public/html/images/home_img/home-slots-sg-ov.png',
        imgAlt: 'slot-spadeGaming',
        route: '/slots/spadeGaming',
        descTranslate: 'SPADEGAMING',
    },
    {
        id: '2',
        imgPath: '/public/html/images/home_img/home-slots-ag.png',
        imgPathOv: '/public/html/images/home_img/home-slots-ag-ov.png',
        imgAlt: 'slot-asiagaming',
        route: '/slots/playace',
        descTranslate: 'ASIA GAMING',
    },
];

export const liveCasinoSettingData = [
    {
        img: '/public/html/images/home_img/home-casino-gd-of.jpg',
        url: '/casino/gd-gaming',
        alt: 'gd-gaming',
    },
    {
        img: '/public/html/images/home_img/home-casino-sb-of.jpg',
        url: '/casino/sexy-baccarat',
        alt: 'ae-baccarat',
    },
    {
        img: '/public/html/images/home_img/home-casino-pt-of.jpg',
        url: '/casino/playtech',
        alt: 'playtech',
    },
    {
        img: '/public/html/images/home_img/home-casino-allbet-of.jpg',
        url: '/casino/allbet2',
        alt: 'allbet',
    },
    {
        img: '/public/html/images/home_img/home-casino-gp-of.jpg',
        url: '/casino/gameplay',
        alt: 'gameplay',
    },
    {
        img: '/public/html/images/home_img/home-casino-sa-of.jpg',
        url: '/casino/sa-gaming',
        alt: 'sa-gaming',
    },
];

export const downloadBannerDesc = function (params) {
    let portalSettings = params.props.portal.settings;
    let t = params.props.t;
    return (
        <div className='download_content'>
            <div className='custom_container'>
                <div className='download-desc'>
                    {!portalSettings.hideDownloadDec && (
                        <p>{t('mobile:mobile.desc_1', 'Hottest Asian Oriented games.') + t('mobile:mobile.desc_2', 'Slot games fully compatible.')}</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export const casinoTopBannerDesc = function (params) {
    // let portalSettings = params.props.portal.settings;
    let t = params.props.t;
    let countryLang = params.props.language.countryLanguageKey.toLowerCase().replace('_', '-');
    const { provider, providerSetting, buttonContent } = params.state;
    return (
        <div className='casino_content'>
            <div className='custom_container'>
                {providerSetting.titleImg && providerSetting.titleImg[countryLang] && (
                    <div className='title-img-container'>
                        <LazyLoadImage className='title-img' src={providerSetting.titleImg[countryLang]} alt='' />
                    </div>
                )}

                <div className='casino-top-desc'>
                    {provider && t('casino:casino.' + provider.toLowerCase() + '.desc_1', '') + ' ' + t('casino:casino.' + provider.toLowerCase() + '.desc_2', '')}
                </div>
                <div className='btn-container'>
                    <div className='primary-btn casino-play-btn' onClick={() => params.lauchGame(false)}>
                        <span>{t(buttonContent)}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const casinoBottomBannerDesc = function (params) {
    // let portalSettings = params.props.portal.settings;
    let t = params.props.t;
    const { provider, buttonContent } = params.state;
    const { settings } = params.props.portal;

    let hideCasinoBottomBannerDescStatus = false;
    if (settings && settings.hideCasinoBottomBannerDesc) {
        hideCasinoBottomBannerDescStatus = settings.hideCasinoBottomBannerDesc;
    }
    return (
        <Fragment>
            {(provider !== 'AB' || provider !== 'AB2') && (
                <Fragment>
                    <div className={core.getComponentClass('casino-bottom-desc', 'casinoBottomDesc')}>
                        {!hideCasinoBottomBannerDescStatus && (
                            <div className='desc-text'>
                                <Trans>
                                    <div>{provider && t('casino:casino.' + provider.toLowerCase() + '.desc_3', '')}</div>
                                    <div>{provider && t('casino:casino.' + provider.toLowerCase() + '.desc_4', '')}</div>
                                </Trans>
                            </div>
                        )}
                        <div className='casino-play-btn primary-btn' onClick={() => params.lauchGame(false)}>
                            {t(buttonContent)}
                        </div>
                    </div>
                </Fragment>
            )}
        </Fragment>
    );
};

export const slotTopBannerDesc = function (params) {
    let t = params.props.t;
    const { provider, currentProvider } = params.state;
    return (
        <div className='desc'>
            {provider !== 'UL' && t('slot:slot.description.new.' + currentProvider, '')}
            {provider === 'UL' && (
                <div className='slot-button-container  '>
                    <div className='slot-desc'>
                        {t('ultimate:ultimate.desc_1', 'This classic remake is packed with a no-') +
                            t('ultimate:ultimate.desc_2', 'nonsense 9 reels, 8 paylines game which functions') +
                            t('ultimate:ultimate.desc_3', 'like a good old land-based slot machine.')}
                    </div>
                    <div className='slotBtnWarpper'>
                        <button
                            type='submit'
                            onClick={() => {
                                params.lauchSlotGame({ provider: 'UL', category: 'SL' }, false);
                            }}
                            className='primary-btn button-35px ul-btn-play'
                        >
                            <span>{t('ultimate:ultimate.playNow')}</span>
                        </button>
                        <button
                            type='submit'
                            onClick={() => {
                                params.lauchSlotGame({ provider: 'UL', category: 'SL' }, true);
                            }}
                            className='red-btn button-35px ul-demo-btn'
                        >
                            <span>{t('ultimate:ultimate.playForFun')}</span>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export const pokerTopBannerDesc = function (params) {
    let t = params.props.t;
    const { currentProvider, pokerPageSettings, customTranslationObj } = params.state;

    return (
        <Fragment>
            <div className='poker_content'>
                <div className='custom_container'>
                    {pokerPageSettings && !pokerPageSettings.hidePokerDesc && (
                        <div className='desc'>
                            {t('poker:' + currentProvider + '.desc1', 'The only mobile Poker apps ') +
                                t('poker:' + currentProvider + '.desc2', 'that lets you play with one hand. ') +
                                t('poker:' + currentProvider + '.desc3', 'Available on Android & iOS ')}
                        </div>
                    )}
                    <div className='btn-container'>
                        <div className='primary-btn play-btn' onClick={() => params.lauchGame(false)}>
                            <span>{customTranslationObj && customTranslationObj.playNow ? customTranslationObj.playNow : t('poker:poker.button.playNow', 'PLAY NOW')}</span>
                        </div>
                    </div>
                </div>
            </div>

            {pokerPageSettings && pokerPageSettings.showBottomBanner && (
                <LazyLoadImage className='bottom-banner' src={pokerPageSettings && pokerPageSettings.showBottomBanner} alt='' />
            )}
        </Fragment>
    );
};

export const pokerBottomBannerDesc = function (params) {
    let t = params.props.t;
    const { currentProvider, pokerPageSettings } = params.state;

    return (
        <Fragment>
            {pokerPageSettings && pokerPageSettings.bottomDesc && pokerPageSettings.bottomDesc === 'doubleDesc' ? (
                <div className='poker-btm-desc-container'>
                    <div className='poker-btm-desc'>
                        <div className='poker-btm-title'>{t('ultimate:ultimate.desc_4', 'Double up your winning')}</div>
                        {t('poker:' + currentProvider + '.desc1', 'The only mobile Poker apps ') +
                            t('poker:' + currentProvider + '.desc2', 'that lets you play with one hand. ') +
                            t('poker:' + currentProvider + '.desc3', 'Available on Android & iOS ')}
                    </div>
                    <div className='poker-btm-desc'>
                        <div className='poker-btm-title'>{t('poker:' + currentProvider + '.desc8', 'Double up your winning')}</div>
                        {t('poker:' + currentProvider + '.desc9', 'After winning any round in the game, the game') +
                            t('poker:' + currentProvider + '.desc10', 'will automatically enter Double up / Double half', ' ')}
                    </div>

                    {pokerPageSettings.showBottomBannerPlayNowButton ? (
                        <div className='poker-btm-button'>
                            <button
                                className='primary-btn poker-btm-btn'
                                onClick={() => {
                                    params.lauchGame(false);
                                }}
                            >
                                <span> {t('poker:poker.button.playNow', 'PLAY NOW')}</span>
                            </button>
                        </div>
                    ) : null}
                </div>
            ) : (
                <div className='desc'>
                    {pokerPageSettings && pokerPageSettings.showPokerSubtitleStatus ? (
                        <p className='pokerSubTitle'>{t('poker:' + currentProvider + '.subTitle', 'Double up your winning')}</p>
                    ) : null}
                    <span>
                        {t('poker:' + currentProvider + '.desc1', 'The only mobile Poker apps ') +
                            t('poker:' + currentProvider + '.desc2', 'that lets you play with one hand. ') +
                            t('poker:' + currentProvider + '.desc3', 'Available on Android & iOS ')}
                    </span>

                    {pokerPageSettings && pokerPageSettings.showBottomBannerPlayNowButton ? (
                        <div className='poker-btm-button'>
                            <button
                                className='primary-btn poker-btm-btn'
                                onClick={() => {
                                    params.lauchGame(false);
                                }}
                            >
                                <span> {t('poker:poker.button.playNow', 'PLAY NOW')}</span>
                            </button>
                        </div>
                    ) : null}
                </div>
            )}
        </Fragment>
    );
};

export const lotteryTopBannerDesc = function (params) {
    let t = params.props.t;
    let countryLang = params.props.language.countryLanguageKey.toLowerCase().replace('_', '-');
    const { currentProvider, providerSetting, displayGames, provider } = params.state;

    return (
        <div className='lottery-bn-desc '>
            <div className={`custom_container ${provider}-custom-container`}>
                {providerSetting.titleImg && providerSetting.titleImg[countryLang] && (
                    <div className='title-img-container'>
                        <LazyLoadImage className='title-img' src={providerSetting.titleImg[countryLang]} alt='' />
                    </div>
                )}
                <div className='lottery-desc'>
                    <Trans>{t('lottery:lottery.' + currentProvider + '.desc', 'Reach out the joy from our latest lottery')}</Trans>
                </div>
                {!(providerSetting && providerSetting.removeBannerBtn) && displayGames.length < 1 && (
                    <button
                        type='submit'
                        className='primary-btn button-35px btn-play-lottery '
                        onClick={() => {
                            params.lauchGame(false);
                        }}
                    >
                        <span>{t('fishing:button.play', 'PLAY NOW')}</span>
                    </button>
                )}
            </div>
        </div>
    );
};

export const fishingTopBannerDesc = function (params) {
    let t = params.props.t;
    let countryLang = params.props.language.countryLanguageKey.toLowerCase().replace('_', '-');
    const { currentProvider, providerSetting, displayGames } = params.state;

    return (
        <div className='fishing_content'>
            <div className='custom_container'>
                {providerSetting.titleImg && providerSetting.titleImg[countryLang] && providerSetting.titleImg[countryLang][currentProvider] && (
                    <div className='title-img-container'>
                        <LazyLoadImage className='title-img' src={providerSetting.titleImg[countryLang][currentProvider]} alt='' />
                    </div>
                )}
                <div className='desc'>
                    <Trans>
                        {t('fishing:' + currentProvider + '.desc1', '') + t('fishing:' + currentProvider + '.desc2', '') + t('fishing:' + currentProvider + '.desc3', '')}
                    </Trans>
                </div>
                {!(providerSetting && providerSetting.removeBannerBtn) && displayGames.length <= 0 && (
                    <div className='btn-container'>
                        <div className='primary-btn play-btn' onClick={() => params.lauchGame(false)}>
                            <span>{t('fishing:button.play', 'PLAY NOW')}</span>
                        </div>
                        {!params.props.portal.settings.hideFishingDemoButton && (
                            <div className='primary-btn demo-btn' onClick={() => params.lauchGame(true)}>
                                {t('fishing:button.playfun', 'DEMO')}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export const fishingBottomBannerDesc = function (params) {
    let t = params.props.t;
    const { currentProvider, fishingPageSettings } = params.state;

    return (
        <div className={core.getComponentClass('fishing-desc2-container', 'fishingBottomDesc')}>
            {Boolean(fishingPageSettings?.bottomDesc) && <div className='fishing-desc2'>{t('fishing:' + currentProvider + '.feature-desc1', '')}</div>}

            <div className='fishing-btm-button'>
                {params.props.portal.settings.ShowFishingPlayButton && (
                    <Fragment>
                        <button className='primary-btn fishing-btm-btn' onClick={() => params.lauchGame(false)}>
                            <span>{t('fishing:button.play', 'PLAY NOW')}</span>
                        </button>
                        <button className='primary-btn demo-btn' onClick={() => params.lauchGame(true)}>
                            <span> {t('fishing:button.playfun', 'DEMO')}</span>
                        </button>
                    </Fragment>
                )}
            </div>
        </div>
    );
};

export const sportTopBannerDesc = function (params) {
    let t = params.props.t;
    let countryLang = params.props.language.countryLanguageKey.toLowerCase().replace('_', '-');
    const { providerSetting, provider } = params.state;

    return (
        <div className='virtual-bn-desc'>
            <div className='custom_container'>
                {providerSetting.titleImg && providerSetting.titleImg[countryLang] && (
                    <div className='title-img-container'>
                        <LazyLoadImage className='title-img' src={providerSetting.titleImg[countryLang]} alt='' />
                    </div>
                )}

                <div className='virtual-desc'>{t('sport:sport.' + provider.toLowerCase() + '.desc', '')}</div>

                {/* havent make launch game dynamic yet */}
                <button
                    type='submit'
                    onClick={() => {
                        provider === 'BR' ? params.launchSportGame({ provider: provider, category: 'S' }, 'VFL', false) : params.lauchGame(false);
                    }}
                    className='primary-btn  button-35px  btn-play-sports '
                >
                    <span>{t('sport:sport.playNow', 'PLAY NOW')}</span>
                </button>
            </div>
        </div>
    );
};

export const esportTopBannerDesc = function (params) {
    let t = params.props.t;
    let countryLang = params.props.language.countryLanguageKey.toLowerCase().replace('_', '-');
    const { providerSetting, provider, esportPageSettings, customTranslationObj } = params.state;

    return (
        <div className='btn-container'>
            <div className='custom_container'>
                {providerSetting.titleImg && providerSetting.titleImg[countryLang] && (
                    <div className='title-img-container'>
                        <LazyLoadImage className='title-img' src={providerSetting.titleImg[countryLang]} alt='' />
                    </div>
                )}
                {esportPageSettings && !esportPageSettings.hideEsportDesc && <div className='virtual-desc'>{t('sport:sport.' + provider.toLowerCase() + '.desc', '')}</div>}
                <div className='primary-btn play-btn esport-btn' onClick={() => params.triggerLoginModal()}>
                    <span>{customTranslationObj && customTranslationObj.playNow ? customTranslationObj.playNow : t('poker:poker.button.playNow', 'PLAY NOW')}</span>
                </div>
            </div>
        </div>
    );
};

export const esportBottomBannerDesc = function (params) {
    let t = params.props.t;
    let countryLang = params.props.language.countryLanguageKey.toLowerCase().replace('_', '-');
    const { providerSetting, provider, esportPageSettings, customTranslationObj } = params.state;

    return (
        <Fragment>
            <div className='btn-container'>
                <div className='custom_container'>
                    {providerSetting.titleImg && providerSetting.titleImg[countryLang] && (
                        <div className='title-img-container'>
                            <LazyLoadImage className='title-img' src={providerSetting.titleImg[countryLang]} alt='' />
                        </div>
                    )}
                    {esportPageSettings && !esportPageSettings.hideEsportDesc && (
                        <div className='virtual-desc'>{t('sport:sport.' + provider.toLowerCase() + '.desc', '')}</div>
                    )}
                    <div className='primary-btn play-btn esport-btn' onClick={() => params.triggerLoginModal()}>
                        <span>{customTranslationObj && customTranslationObj.playNow ? customTranslationObj.playNow : t('poker:poker.button.playNow', 'PLAY NOW')}</span>
                    </div>
                </div>
            </div>

            {esportPageSettings && esportPageSettings.customImgDesc && (
                <div className='esport-bottom'>
                    <LazyLoadImage className='img-desc' src={esportPageSettings.customImgDesc} alt='' />
                </div>
            )}
        </Fragment>
    );
};

export const games3DTopBannerDesc = function (params) {
    let t = params.props.t;
    const { provider } = params.state;

    return (
        <div className='games_content'>
            <div className='custom_container'>
                <div className='games-top-desc'>
                    {
                        <Trans>
                            {' '}
                            {t('games:games.provider.' + provider.toLowerCase() + '.desc', 'The most captivating games.<br>Bringing your imagination to the next level!')}
                        </Trans>
                    }
                </div>
            </div>
        </div>
    );
};
